import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enElementLocale from 'element-ui/lib/locale/lang/en'
import zhElementLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'
import Cookies from 'js-cookie'
import envMode from '@/utils/ajax/http'
Vue.use(VueI18n)
const messages = {
  en: {
    ...enElementLocale,
    ...enLocale
  },
  zh: {
    ...zhElementLocale,
    ...zhLocale
  }
}
let locale
locale = Cookies.get('lang') ? Cookies.get('lang') : (navigator.language || navigator.userLanguage).substr(0, 2)
if (locale !== 'en' && locale !== 'zh') locale = 'zh'
Cookies.set('lang', locale, { domain: envMode.env.DOMAIN })
// if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat') {
//   locale = Cookies.get('lang') ? Cookies.get('lang').substr(0, 2) : (navigator.language || navigator.userLanguage).substr(0, 2)
// } else {
//   locale = 'zh'
// }
const i18n = new VueI18n({
  // locale: Cookies.get('lang') ? Cookies.get('lang').substr(0, 2) : (navigator.language || navigator.userLanguage).substr(0, 2),
  // locale: 'zh',
  locale,
  messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js